export enum EventType {
  PULSE = 'pulse',
  LEAVE_PAGE = 'leave-page',
  VISIT_PAGE = 'visit-page',
  PAGE_VISIBLE = 'page-visible',
  PAGE_INVISIBLE = 'page-invisible',
  CURRICULUM_EVENT = 'curriculum-event',
  CURRICULUM_TOPIC_EVENT = 'curriculum-topic-event',
}

export enum VideoEventType {
  PLAY = 'play',
  PAUSE = 'pause',
  SEEK = 'seek',
  END = 'end',
  SKIP_EVENT = 'skip', // this is a custom event type for when a user goes to the activities tab while video is playing, it skips browser events
}

interface Extra {
  [key: string]: unknown
}

export interface EventData {
  eventName: string
  viewKey: string
  extra?: Extra
}

export type TimeInterval = [number, number]

export interface VideoWatchEventData {
  eventName: string
  viewKey: string
  videoId: string
  videoTime: number | null
  extra?: Extra
}

export interface Event extends EventData {
  id: string
  time: string
  viewportId?: string
}

export interface VideoWatchEvent extends VideoWatchEventData {
  id: string
  createdAt: string
  viewportId?: string
}

export enum EventDetectionMethod {
  NEXT_ROUTE_CHANGE_START_EVENT = 'router fired routeChangeStart',
  ON_CURRICULUM_CHEST_CLICK = 'On curriculum chest click',
  ON_START_MAPPING_QUIZ_CLICK = 'On start mapping quiz click',
  ON_RETAKE_MAPPING_QUIZ_CLICK = 'On retake mapping quiz click',
  ON_RETAKE_MAPPING_QUIZ_FROM_MT_CARD_CLICK = 'On retake mapping quiz from mastery track card click',
  ON_MAPPING_QUIZ_ANSWER_CLICK = 'On mapping quiz answer click',
  ON_MAPPING_QUIZ_COMPLETE_CLICK = 'On mapping quiz complete click',
  ON_MAPPING_QUIZ_FINISH = 'On mapping quiz finish',
  ON_CURRICULUM_CERTIFICATE_CLICK = 'On curriculum certificate click',
  ON_CURRICULUM_ITEM_CLICK = 'On curriculum item click',
  ON_PREREQUISITE_ITEM_CLICK = 'On prerequisite item click',
  ON_SELECT_PREREQUISITE_LEVEL = 'On select prerequisite level',
  ON_SELECT_CURRICULUM_LEVEL = 'On select curriculum level',
  ON_CURRICULUM_TOPIC_CLICK = 'On curriculum topic click',
  ON_CURRICULUM_CONTENT_CLICK = 'On curriculum content item click',
  ROUTER_AS_PATH_CHANGED = 'router.asPath changed',
  DOCUMENT_VISIBILITY_CHANGE_EVENT = 'document visibilitychange event',
  DOCUMENT_BEFOREUNLOAD_EVENT = 'document beforeunload event',
  PULSE_INTERVAL_EVENT = 'pulse interval event',
}
